//配置路由
import Vue from 'vue'
import VueRouter from 'vue-router'
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
//使用插件
Vue.use(VueRouter)
//引入路由组件
const Home = () => import('@/pages/home')

//配置路由
const routes = [{
        path: '/',
        component: Home,
    },
]
const router = new VueRouter({
    routes: routes,
    mode: 'history'
    // mode:'hash'
})
//beforeEach每次进行路由跳转时都会执行
router.beforeEach((to, from, next) => {
    next();
})
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)

});
export default router